function getAuthToken() {
  return localStorage.getItem("authToken");
}

export function getAuthHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  };
}
